<template>
    <el-card>
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" >
            <el-row>
                <el-col>
                    <el-form-item label="投诉标题:" prop="title">
                        <el-input v-model="form.title" v-if="type=='add'"></el-input>
                        <span v-if="type=='edit'">{{form.title}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="投诉内容" style="z-index: -99">
                        <!-- <ueditor :description.sync="form.description" @getUeContent="getUeContent" v-if="type=='add'"></ueditor> -->

                        <ueditor v-model="form.description" :config="myConfig" :key="1" :value="2" @ready="editorReady" v-if="type=='add'"></ueditor>
                        <span v-if="type=='edit'" v-html="form.description"></span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <!--处理组-->
                    <el-form-item label='处理组'  prop="group">
                        <el-select v-model="form.group" placeholder="请选择" filterable @change="departmentChange" v-if="type=='add'">
                            <el-option v-for="item in departmentList" :key="item.index" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                        <span v-if="type=='edit'">{{form.group}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <!--处理人-->
                    <el-form-item label="人名" >
                        <div class="el-form__inline" v-if="type=='add'">
                            <notifyTab :data="form.user" :getData="getNotifyData" style="display: contents"></notifyTab>
                            <router-link :to="{ path:'/requesterList',query: { callback:getNoticer,moreSelect:true } }">
                                <!--<span  class="noticeAdd">+</span>-->
                                <el-button type="primary">选择人员</el-button>
                            </router-link>
                        </div>
                        <span v-for="item in form.user" v-if="type=='edit'">{{item}}&nbsp;&nbsp;&nbsp;</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--&lt;!&ndash;人员&ndash;&gt;-->
            <!--<el-row>-->
                <!--<newTag :dadLabel="form.user" v-on:getLabelFromSon="getLabelFromSon"></newTag>-->
            <!--</el-row>-->

            <el-row>
                <el-col>
                    <el-form-item label="编号:" prop="serialNumber">
                        <el-input v-model="form.caseNumber" v-if="type=='add'"></el-input>
                        <span v-if="type=='edit'">{{form.caseNumber}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="联系电话:" prop="phone">
                        <el-input v-model="form.phone" v-if="type=='add'"></el-input>
                        <span v-if="type=='edit'">{{form.phone}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="联系邮箱:" prop="email">
                        <el-input v-model="form.email" v-if="type=='add'"></el-input>
                        <span v-if="type=='edit'">{{form.email}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="匿名" prop="anonymous">
                        <el-radio v-model="form.anonymous"  label="1" :disabled="type=='add'?false:true">是</el-radio>
                        <el-radio v-model="form.anonymous"  label="0" :disabled="type=='add'?false:true">否</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="备注" v-if="type=='edit'">
                        <el-input type="textarea" :rows="2" placeholder="请输入内容"
                                  v-model="form.remarks" v-if="role=='manager'"></el-input>
                        <span v-if="role=='my'">{{form.remarks}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="状态" v-if="type=='edit'">
                        <el-radio v-model="form.status"  label="455" v-if="role=='manager'">处理中</el-radio>
                        <el-radio v-model="form.status"  label="457" v-if="role=='manager'">完成</el-radio>
                        <span v-if="role=='my'">{{form.status=='457'?'完成':'处理中'}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建"}}</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>

        </el-form>
    </el-card>
</template>

<script>
    import commonServices from "../../services/common.service"
    import services from './complaintsManage.service'
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";
    import ueditor from "../../components/ueditor.vue"

    import notifyTab from "../common/notifyTab.vue"
    import { getRules } from "./complaintsManage.rules";
    const rules = getRules();
    export default {
        name: "addMyComplaints",
        props:{
            type:{
                type:String,
                default:"add"
            },
            role:{
                type:String,
                default:'my'
            },
            serialNumber:String,
            callback:Function,
        },
        components:{ ueditor,notifyTab},
        data(){
            return{
                formName:"form",
                form:{
                    title:'',
                    description:'',
                    phone:'',
                    user:[],
                    group:'',
                    email:'',
                    caseNumber:'',
                    anonymous:''
                },
                dis_user:true,
                departmentList:[],      // 处理组
                createUser:'',
                rules:rules,
                isSubmit:false,
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    // serverUrl: 'http://35.201.165.105:8000/controller.php'/cr/v1/review
                    // serverUrl:Config.baseURL+"upload",
                    // serverUrl:'http://wedof.beta.autoai.com/upload/'
                    serverUrl:Config.BASE_API + "upload/",
                },
            }
        },
        created(){
            this.getDepartment()
            if (this.type=='edit'){
                this.$modal.title='投诉详情'
                this.getDetail()
            }
        },
        methods:{
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                  // console.log('编辑器内容发生了变化:', editorInstance.getContent());getContentTxt()
                  // _this.form.Body = editorInstance.getContent()
                   _this.form.description = editorInstance.getContent()
                });
            },
            // 服务组
            getDepartment(){
                let params= {
                    departmentId:99999,
                    type:'group'
                }
                commonServices.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;
                })
            },
            departmentChange(){
                this.dis_user = this.form.group ? false : true;
            },
            getDetail(){
                services.getComplaintsDetail({serialNumber:this.serialNumber}).then(res=>{
                    this.form=res
                })
            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.user=this.arrayUnique(this.form.user.concat(obj))
                console.log(this.form.user);
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.user=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr
            },
            getLabelFromSon(val){
                this.form.user=val
            },
            getUeContent(val){
                this.form.description = val;
            },
            submit(){

                if (this.type=='edit'&&this.role=='my'){
                    this.close(true)
                } else{
                    let formName = this.formName;
                    this.$refs[formName].validate((valid) => {
                        if(valid){
                            //再进行邮箱和电话格式的校验
                            if (this.isPhoneValidate(this.form.phone)) {
                                if (this.isEmailValidate(this.form.email)) {
                                this.isSubmit=true
                                // console.log(this.form);
                                let params={
                                    ...this.form,
                                    user:this.form.user.map(item=>item.internalUserid),
                                    createUser:window.localStorage.getItem('internalUserid')
                                }
                                // console.log(params);
                                // let params = this.getParams();
                                    if(this.type == 'edit'){
                                    this.updateComplaints(params);
                                    }else{
                                    this.addComplaints(params);
                                    // this.$message.success('验证成功')
                                    }
                                }else{
                                    this.$message.error('邮箱格式错误，请重新填写')
                            }
                            }else{
                                this.$message.error('电话格式错误，请重新填写')
                            }
                        }else{
                            this.isSubmit=false
                            this.$message.error('✳为必填项，请全部填写')
                        };
                        return valid;
                    })
                }

            },
            getParams(){

            },
            updateComplaints(params){
                services.updateComplaints(params).then(res => {
                    this.$message.success("投诉编辑成功");
                    this.close();
                    this.$router.push({
                        path:'/myComplaints'
                    })
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },
            addComplaints(params){
                services.addComplaints(params).then(res => {
                    this.$message.success("投诉创建成功");
                    this.close();
                    this.$router.push({
                        path:'/myComplaints'
                    })
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },
            isPhoneValidate(val){
                let reg=/^1[3-8]\d{9}$/
                return reg.test(val);
            },
            isEmailValidate(val){
                let reg=/^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.(?:com|cn)$/
                return reg.test(val)
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },

        }
    }
</script>

<style scoped>

</style>
